import React from "react";
import { Link } from "react-router";
import { IconButton, FlatButton } from "material-ui";
import ExitToAppIcon from "material-ui/svg-icons/action/exit-to-app";

import GodModeControl from "./god-mode-control.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../../stores/UserStore";
import UserActions from "../../actions/UserActions";

class AccountAppBarItem extends React.Component {
  constructor(props) {
    super(props);
    this.manage = this.manage.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static contextTypes = {
    router: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

  logout(e) {
    e.preventDefault();
    e.stopPropagation();
    UserActions.logout();
  }

  manage() {
    this.context.router.push("/account");
  }

  render() {
    let el,
      {
        isLoggedIn,
        data,
        condensedUsers,
        activeGodUser,
        activeGodRole,
        roles,
        godStealthMode,
        compact
      } = this.props;

    if (!isLoggedIn || !data) {
      return (
        <div style={{ marginRight: 7 }}>
          <Link to="/login">
            <FlatButton label={compact ? "Login" : "Login to your account"} />
          </Link>
        </div>
      );
    }

    if (data.god) {
      el = (
        <GodModeControl
          style={{ display: "inline-block" }}
          condensedUsers={condensedUsers}
          activeGodUser={activeGodUser}
          activeGodRole={activeGodRole}
          roles={roles}
          godStealthMode={godStealthMode}
        />
      );
    } else {
      el = !compact && (
        <div
          style={{
            display: "inline-block",
            fontSize: 14,
            color: "#fff",
            lineHeight: 1.2,
            marginTop: 3,
            cursor: "pointer",
            marginRight: 10
          }}
          onTouchTap={this.manage}
        >
          <div style={{ fontWeight: "bold" }}>
            {data.owner && data.owner.organization}
          </div>
          <div>{data.name || data.email}</div>
        </div>
      );
    }

    return (
      <div style={{ marginTop: -5, display: "flex", alignItems: "center" }}>
        {el}
        <IconButton
          tooltip="Log out"
          onTouchTap={this.logout}
          style={data.god && { verticalAlign: 5 }}
        >
          <ExitToAppIcon color="#fff" />
        </IconButton>
      </div>
    );
  }
}

export default connectToStores(AccountAppBarItem);



// WEBPACK FOOTER //
// ./src/app/components/partials/account-app-bar-item.jsx